export type Tab = "HOME" | "SECURITY" | "AUTOMATION" | "EVENTS" | "SYSTEM";
export type Connectivity = "ONLINE" | "UPDATING" | "OFFLINE";
export type CommandPhase = "IDLE" | "PRECHECKING" | "EXECUTING" | "CONFIRMED" | "FAILED";

export const NAVIGATION_TABS: ReadonlyArray<{ id: Tab; label: string; glyph: string }> = [
  { id: "HOME", label: "Visão", glyph: "◇" },
  { id: "SECURITY", label: "Segurança", glyph: "⬡" },
  { id: "AUTOMATION", label: "Automação", glyph: "⌁" },
  { id: "EVENTS", label: "Eventos", glyph: "◉" },
  { id: "SYSTEM", label: "Sistema", glyph: "▦" },
];

export function commandsAreLocked(input: {
  canOperate: boolean;
  operationLocked: boolean;
  phase: CommandPhase;
  connectivity: Connectivity;
}): boolean {
  return !input.canOperate
    || input.operationLocked
    || input.phase === "PRECHECKING"
    || input.phase === "EXECUTING"
    || input.connectivity !== "ONLINE";
}

export function isOperationalReasonValid(reason: string): boolean {
  return reason.trim().length >= 5;
}
